import React from 'react'

class LeftBarSheets extends React.Component {

    viewSheet = (event) => {
        event.preventDefault()
        this.props.viewSheet(event.target.dataset.id)
    }

    handleDivNames = (index) => {
        return (this.props.sheet && index === this.props.sheet.sheetIndex) ? 'sheetThumbnail active' : 'sheetThumbnail' 
    }

    render() {
        return (
            <ul className="sheets">
                {this.props.sheets && this.props.sheets[0].sheetImage !== null && this.props.sheets.sort(function (a, b) { return a["sheetIndex"] - b["sheetIndex"] }).map((x, i) => {
                    const isActive = this.props.sheet && x.sheetIndex === this.props.sheet.sheetIndex;
                    const activeStyle = isActive ? { backgroundColor: '#CBDEF4' } : {};
                    return (<li key={`left-hand-slide-${i}`} style={activeStyle}>
                        <img src={`data:image/jpeg;base64,${x.sheetImage.imageBytes}`} alt={i} width="180" height="115" onClick={this.viewSheet} data-id={x.sheetIndex} />
                    </li>);
                }
                )}
            </ul>
        )
    }
}

export default LeftBarSheets